import { gql } from 'apollo-angular';

export const documentPhase = gql`
	fragment DocumentPhase on OrganizationPhaseOutput {
		id
		type
		position
		updateTimestamp
	}
`;

export const documentSection = gql`
	fragment DocumentSection on OrganizationSectionOutput {
		id
		type
		position
		updateTimestamp
	}
`;

export const documentModule = gql`
	fragment DocumentModule on OrganizationModuleOutput {
		id
		position
		updateTimestamp
	}
`;

export const documentLocalization = gql`
	fragment DocumentLocalization on DocumentI18nOutput {
		url
		name
		locale
	}
`;

export const cvTemplateLocalization = gql`
	fragment CvTemplateLocalization on CvTemplateI18nOutput {
		name
		locale
	}
`;

export const modulePageDocuments = gql`
	fragment ModulePageDocuments on DocumentOutput {
		id
		type
		ownerId
		updateTimestamp
		lastOpenTimestamp
		creationTimestamp
		phase {
			id
		}
		module {
			id
		}
		localizations {
			url
			name
			locale
		}
	}
`;
